export const PERSONALIZED = 'personalized';
export const NON_PERSONALISED = 'non-personalized';
export const REGISTERED = 'registered';
export const DIGITAL = 'digital';
